import Link from "next/link";

export function SuperLink({
  href,
  ...rest
}: React.ComponentProps<typeof Link>) {
  return <Link href={href} prefetch={false} {...rest} />;
}
